<template>
  <div id="box">
    <!-- 头部组件 -->
    <header class="box">
      <headers :type='"blue"'></headers>
    </header>
    <div class="home">
      <div class="content flex">
      <div class="left">
          <div class="tab_title">帮助2中心</div>
          <div class='tab_item' :class='page == "usercentre"?"active":""' @click="changePage('usercentre')">等级常见问题 <i class='icon-youjiantou iconfont'></i></div>
        </div>
        <div class="right">
          <usercentre v-if="page == 'usercentre'"></usercentre>
        </div>
    </div>
    </div>
    <!-- 尾部组件 -->
    <div class="box box1">
      <tails></tails>
    </div>
  </div>
</template>

<script>
import headers from "@/components/header";
import tails from "@/components/tail";
import usercentre from '@/view/help/usercentre';


export default {
  data() {
    return {
      page:'usercentre'
    };
  },
  components: {
    headers,
    tails,
    usercentre,
  },
  created() {
    
  },
   methods:{
    changePage(page){
      this.page = page
    }
  }

};
</script>

<style lang='less' scoped>
#box {
  // position: absolute;
  // left: 0;
  // top: 0;
  // // width: 100%;
  // height: 100%;
   background: #f3f6f8;
}
.box {
  background:  #0068b7;
}
.box1 {
  background: #f2f2f2;
}
.home {
  height: calc(100% - 243px);
  background-color: #f3f6f8;
  min-height: 690px;
  overflow: auto;
  .content{
    height: 100%;
    background-color: #fff;
  }
  .left {
    width: 300px;
    min-height: 690px;
    background-color: #DEE8F8;
    .tab_title{
      color: #333333;
      height: 37px;
      font-size: 26px;
      line-height: 37px;
      color: #333333;
      opacity: 1;
      margin: 40px 0 13px 20px;

      
    }
    .tab_item{
      height: 54px;
      line-height: 54px;
      color: #333;
       
      font-size: 22px;
      opacity: 1;
      text-indent: 70px;
      position: relative;
      transition: all 0.5s;
      cursor: pointer;
      .iconfont{
        position: absolute;
        top: 50%;
        right: 20px;
        font-size: 20px;
        transform: translateY(-50%);
      }
    }
    .tab_item:hover{
      color:  #0068b7;
      background: #fff;
      transition: all 0.5s;
    }
    .active{
      color:  #0068b7;
      background: #fff;
    }
  }
  .right {
    width: 980px;
    height: 100%;
    position: relative;
    .iframe {
      width: 100%;
      height: 100%;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/help/index.vue